import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { useTranslation } from "react-i18next";
import TabList from "@mui/lab/TabList";
import { TabContext } from "@mui/lab";
import { UiTextIconButton } from "./UiButton";
import { AddSquareIcon } from "../../../styles/img/svg/AddSquareIcon";

export const UiTab = (props) => {
  const { t } = useTranslation();

  const [value, setValue] = React.useState(
    props.selected ? props.selected : "1",
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (props.tabOnChange) {
      props.tabOnChange(newValue);
    }
  };

  const Tabnavs = props.tabNav;

  const className = `df-cust-tab ${props.className || ""}`.trim();

  return (
    <>
      <Box className={className}>
        <TabContext
          value={value}
          orientation={props?.orient == "vertical" ? "vertical" : "horizontal"}
        >
          <Box className={props?.addIconTabHeader && "df-flex-tabheader"}>
            <TabList onChange={handleChange} aria-label="dfcc">
              {Tabnavs.map((tabN) => (
                <Tab key={tabN.id} label={tabN.label} value={tabN.value} />
              ))}
            </TabList>
            {props?.addIconTabHeader && (
              <UiTextIconButton
                onClick={props?.addbuttonOnclick}
                icon={<AddSquareIcon />}
                name={t("New Mail")}
                className="df-primary-underlined-text-icon-btn df-putib-dark"
                beforeIcon
              />
            )}
          </Box>
          {props.children}
        </TabContext>
      </Box>
    </>
  );
};
